import type { IconNode } from '../types';

/**
 * @name hat-chef
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxMy44NUE0IDQgMCAwIDEgNy40IDZhNSA1IDAgMCAxIDkuMiAwIDQgNCAwIDAgMSAxLjQgNy44NVYyMUg2WiIgLz4KICA8cGF0aCBkPSJNNiAxN2gxMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hat-chef
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatChef: IconNode = [
  [
    'path',
    { d: 'M6 13.85A4 4 0 0 1 7.4 6a5 5 0 0 1 9.2 0 4 4 0 0 1 1.4 7.85V21H6Z', key: '1yj1zn' },
  ],
  ['path', { d: 'M6 17h12', key: '1jwigz' }],
];

export default hatChef;
